import useRequest, { Config } from './swr'

export const useCurrentUser = (config?: Config<User>) =>
  useRequest<User>({ method: 'GET', url: `/v3/me/` }, config)
